import { Route, Routes } from 'react-router-dom'
import UserProfilePage from '../../pages/settings/UserProfilePage'
import VerifyEmailPage from '../../pages/settings/VerifyEmailPage'

const SettingsRoutes = () => {
  return (
    <Routes>
      <Route path="profile" element={<UserProfilePage />} />
      <Route path="verify-email/:id/:hash" element={<VerifyEmailPage />} />
    </Routes>
  )
}

export default SettingsRoutes
